import React, { useState, useEffect } from 'react';
import './CookieConsent.css';

const STORAGE_KEY = 'sebusca_cookie_consent';

function CookieConsent() {
  const [visible, setVisible] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    try {
      if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
    } catch (_) {}
  }, []);

  const accept = () => {
    try {
      localStorage.setItem(STORAGE_KEY, 'accepted');
    } catch (_) {}
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <>
      <div
        className="cookieConsent"
        role="dialog"
        aria-label="Aviso de cookies"
      >
        <p>
          Usamos cookies para melhorar sua experiência. Ao continuar, você
          concorda com nossa{' '}
          <button
            type="button"
            onClick={() => setModalOpen(true)}
            style={{
              background: 'none',
              border: 'none',
              color: 'inherit',
              textDecoration: 'underline',
              cursor: 'pointer',
              padding: 0,
              font: 'inherit',
              fontWeight: 600,
            }}
          >
            Política de Privacidade
          </button>{' '}
          e uso de cookies.
        </p>
        <button type="button" className="cookieConsentBtn" onClick={accept}>
          Aceitar
        </button>
      </div>

      {modalOpen && (
        <div
          className="cookieModalOverlay"
          onClick={() => setModalOpen(false)}
          style={{
            position: 'fixed',
            inset: 0,
            backgroundColor: 'rgba(0, 0, 0, 0.65)',
            zIndex: 10000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 16,
          }}
        >
          <div
            className="cookieModalContent"
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: '#fff',
              borderRadius: 12,
              maxWidth: 680,
              width: '100%',
              maxHeight: '85vh',
              overflowY: 'auto',
              padding: 24,
              boxShadow: '0 10px 30px rgba(0,0,0,0.25)',
              position: 'relative',
              lineHeight: 1.6,
              color: '#27173b',
            }}
          >
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                borderBottom: '1px solid #eee',
                paddingBottom: 12,
                marginBottom: 16,
              }}
            >
              <h3 style={{ margin: 0, fontSize: 20, fontWeight: 800 }}>
                Política de Privacidade & Cookies
              </h3>
              <button
                type="button"
                onClick={() => setModalOpen(false)}
                style={{
                  background: 'transparent',
                  border: 'none',
                  fontSize: 20,
                  cursor: 'pointer',
                  padding: '4px 8px',
                  fontWeight: 'bold',
                }}
                aria-label="Fechar modal"
              >
                ✕
              </button>
            </div>

            <h4>1. Informações que coletamos</h4>
            <p>
              Coletamos informações fornecidas diretamente por você (detalhes da
              conta, anúncios, mensagens no chat), dados técnicos de navegação e
              localização aproximada para aproximar compradores e vendedores.
            </p>

            <h4>2. Uso de Cookies</h4>
            <p>
              Utilizamos cookies essenciais (para manter sua sessão segura),
              cookies funcionais (como preferências de busca e filtros) e
              cookies de análise de desempenho da plataforma.
            </p>

            <h4>3. Seus Direitos</h4>
            <p>
              Você pode solicitar a qualquer momento a visualização, alteração
              ou exclusão permanente de seus dados pessoais através das
              configurações da sua conta.
            </p>

            <div
              style={{
                marginTop: 24,
                textAlign: 'right',
                borderTop: '1px solid #eee',
                paddingTop: 16,
              }}
            >
              <button
                type="button"
                className="cookieConsentBtn"
                onClick={() => {
                  accept();
                  setModalOpen(false);
                }}
              >
                Aceitar e fechar
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default CookieConsent;
